import "@js/pixi.js";
import "@js/pixi-spine.js";
function SpineLoader() {
  // 每次加载动画资源都会存入spineContainer，重复使用时会先去spineContainer中寻找
  let spineContainer = {};
  /*
   * 加载spine动画
   * @param {String} spineUrl 动画资源地址
   * @param {NodeElement} dom 承载容器 如果为 false 则不挂载
   * @param {Number} w 宽度
   * @param {Number} h 高度
   * @param {Number} spineW 动画素材的宽度
   * @param {Number} spineH 动画素材的高度
   * @return {Promise} 异步返回spine操作对象 播放动画方法：spine.state.addAnimation(0, '动画名', true, 0);
   * */
  return function loadSpine(
    spineUrl,
    dom,
    spineW = 0,
    spineH = 0,
    w = 0,
    h = 0
  ) {
    if (!dom) {
      // var app = new PIXI.Application();
      // app.loader.add("spineCharacter", spineUrl, { crossOrigin: true });
      return;
    }
    w = w || dom.offsetWidth;
    h = h || dom.offsetHeight;
    var app = new PIXI.Application({
      width: w,
      height: h,
      transparent: true,
      resolution: 3,
      useContextAlpha: true,
    });
    return new Promise(function (resolve, reject) {
      dom.appendChild(app.view);
      app.view.style.transform = "scale(.3333)";
      app.view.style.transformOrigin = "left top";
      if (spineContainer[spineUrl]) {
        app.loader.load(function () {
          var animation = new PIXI.spine.Spine(
            spineContainer[spineUrl].spineCharacter.spineData
          );
          loadComplete(animation, resolve);
        });
      } else {
        app.loader
          .add("spineCharacter", spineUrl, { crossOrigin: true })
          .load(function (loader, resources) {
            spineContainer[spineUrl] = resources;
            var animation = new PIXI.spine.Spine(
              resources.spineCharacter.spineData
            );

            loadComplete(animation, resolve);
          });
      }
    });

    function loadComplete(animation, resolve) {
      app.stage.addChild(animation);
      animation.x = w / 2;
      animation.y = (h * h) / w / 2;
      animation.scale.set(Math.min(w / spineW, h / spineH));
      resolve({ app, animation });
    }
  };
}

export default SpineLoader;
